//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';

import {
  IPartialState,
  NavGroup,
  StateFactory,
  componentNameToTemplate,
  hasAllFeatures,
  hasFeature,
  lazyLoadModule,
} from 'app/initialization/routing/stateHelpers';

// Sets default values for state data
function ScheduleStateFactory(state: IPartialState) {
  const accessFn = state.data?.hasAccess ?? (() => true);
  const data = {
    title: 'Schedule',
    navGroup: NavGroup.PUBLISHING,
    ...state.data,
    hasAccess: () =>
      hasAllFeatures(FeatureNames.Social, FeatureNames.SocialDashboards) &&
      accessFn(),
  };

  return StateFactory({
    ...state,
    data,
  });
}

export const states = {
  schedule: ScheduleStateFactory({
    url: '/schedule',
    redirectTo: 'schedule.calendar',
    template: componentNameToTemplate('schedulePage'),
    resolve: {
      ...lazyLoadModule(
        'curalate.schedule',
        () => import('@universal-scheduling/ScheduleApp'),
      ),
    },
  }),

  'schedule.calendar': ScheduleStateFactory({
    url: '/calendar?:startDate&:endDate&:view&:platform',
    views: {
      'schedule-header': {
        template: componentNameToTemplate('calendarHeader'),
      },
    },
  }),

  'schedule.drafts': ScheduleStateFactory({
    url: '/drafts?:platform',
    views: {
      'schedule-header': {
        template: componentNameToTemplate('draftsHeader'),
      },
    },
  }),
  'schedule.scheduler': ScheduleStateFactory({
    url: '/scheduler?:postType&:copiedScheduledPostId&:copiedDraftId&:targetCuid&:scheduledPostId&:draftPostId&:postTimeMs&:hashtag',
    views: {
      'schedule-header': {
        template: componentNameToTemplate('schedulerHeader'),
      },
    },
  }),
  'schedule.inspiration': ScheduleStateFactory({
    url: '/inspiration?:dateRange&:category',
    views: {
      'schedule-header': {
        template: componentNameToTemplate('inspirationHeader'),
      },
    },
  }),
  'schedule.inspiration-hashtag': ScheduleStateFactory({
    url: '/inspiration/:network/hashtag/:hashtagId?:dateRange&:category',
    views: {
      'schedule-header': {
        template: componentNameToTemplate('inspirationHashtagHeader'),
      },
    },
  }),
};
